import { ChevronDownIcon } from '@chakra-ui/icons';
import {
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Button,
} from '@chakra-ui/react';
import { useCustomTheme } from '../../contexts/CustomThemeContext';


interface TravelModeSelectorProps {
    value: string;
    onChange: (value: string) => void;
    options: string[];
}

export const CustomMenu: React.FC<TravelModeSelectorProps> = ({
    value,
    onChange,
    options,
}) => {
    const { theme } = useCustomTheme();

    const selected = options.find((m) => m === value);
    const isPlaceholder = !selected;

    return (
        <Menu>
            <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                fontWeight="700"
                variant="outline"
                border="1px solid"
                borderColor={theme.inputBorder}
                _hover={{ borderColor: theme.inputBorderFocus, bg: theme.hover }}
                _focus={{
                    borderColor: theme.inputBorderFocus,
                    boxShadow: `0 0 0 1px ${theme.inputBorderFocus}`,
                }}
                w="100%"
                textTransform="capitalize"
                color={selected ? theme.text : theme.inputPlaceholder}
                bg={theme.inputBg}
            >
                {selected?.toLowerCase() || 'Select Mode'}
            </MenuButton>

            <MenuList
                maxH="200px"
                overflowY="auto"
                bg={theme.name === "dark" ? "#111827" : "#FFFFFF"}
                background={theme.name === "dark" ? "#111827" : "#FFFFFF"}
                border="1px solid"
                borderColor={theme.border}
                boxShadow="xl"
                color={theme.text}
                opacity={1}
                backdropFilter="none"
                filter="none"
                zIndex={2000}
            >
                {options.map((m) => (
                    <MenuItem
                        key={m}
                        onClick={() => onChange(m)}
                        bg={theme.name === "dark" ? "#111827" : "#FFFFFF"}
                        color={theme.text}
                        _hover={{ bg: theme.hover }}
                        _focus={{ bg: theme.hover }}
                        textTransform="capitalize"
                    >
                        {m.toLowerCase()}
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};